import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';

type DeleteSectorParams = {
    propId: string;
    areaId: string;
    sectorId: string;
};

export function useDeleteSector() {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();
    return useMutation({
        mutationFn: async ({ propId, areaId, sectorId }: DeleteSectorParams) => {
            try {
                return (await api.delete(`/user/prop/${propId}/area/${areaId}/sector/delete/${sectorId}`, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao deletar setor');
            }
        },
        onSuccess: (_, { propId }) => {
            queryClient.invalidateQueries({ queryKey: ['sectors'] });
            queryClient.invalidateQueries({ queryKey: ['propertyId', propId] });
        },
        onError: error => console.error('Erro ao deletar setor:', getApiErrorMessage(error, 'Erro ao deletar setor')),
    });
}
